<template>
  <div>
    <div v-if="loading" class="row p-5">
      <div class="col-10">
        <spinner></spinner>
      </div>
    </div>

    <div v-else class="row p-5">
      <div class="col-10">

        <form @submit.prevent="promiseSaveSettings = saveSettings()">
          <div class="container-fluid">
            <amio-chat-settings v-if="channel.type === 'amio_chat'"
                                :errors="errors"
                                :settings="settings"
                                :edit-mode="editMode"></amio-chat-settings>

            <div v-else>
              <p class="text-muted mb-4">
                This platform doesn't have any settings.
              </p>
            </div>

            <div v-if="editMode" class="row mb-3">
              <div class="col-12">
                <button class="btn btn-success"
                        v-busy-button="promiseSaveSettings">
                  Save
                </button>
              </div>
            </div>

          </div>
        </form>
      </div>

      <div class="col-2">
        <toggle-edit class="d-flex justify-content-end"
                     :editMode="editMode"
                     @click="toggleEditMode"></toggle-edit>
      </div>

    </div>
  </div>
</template>

<script>
  import ChannelDetailField from '@/components/administration/common/Field'
  import AmioChatSettings from '@/components/administration/channel/amio-chat/AmioChatSettings'
  import settingsService from '@/services/amio-api/settings.service'
  import {prepareChannel} from '@/components/administration/channel/router-guard-handler'
  import ToggleEditBtn from '@/components/administration/common/ToggleEditButton'
  import formValidatorMixin from '@/mixins/form-validator.mixin'
  import loadingMixin from '@/mixins/loading.mixin'
  import eventBus from '@/services/event-bus/event-bus'

  export default {
    mixins: [
      formValidatorMixin,
      loadingMixin
    ],

    components: {
      'amio-chat-settings': AmioChatSettings,
      'channel-field': ChannelDetailField,
      'toggle-edit': ToggleEditBtn
    },

    store: {
      channel: 'administration.channelDetail.channel',
      settings: 'administration.channelDetail.settings',
      settingsEdit: 'administration.channelDetail.settingsEdit'
    },

    data() {
      return {
        errors: {},
        editMode: false,
        promiseSaveSettings: null
      }
    },

    methods: {
      // TODO to a mixin
      toggleEditMode() {
        this.errors = {
          domains_whitelist: false
        }
        this.editMode = !this.editMode
      },

      clearErrors(key) {
        if (!key) this.errors = {}

        this.errors[key] = null
      },

      saveSettings() {
        this.formValidator_clearErrors()

        return settingsService.patch(this.channel.id, this.settingsEdit, [422])
          .then(settings => {
            this.settings = settings
            this.toggleEditMode()
          })
          .catch(error => {
            if (error.response.status !== 422) return

            this.formValidator_displayError(error)
          })
          .then(() => {
            this.promiseSaveSettings = null
          })
      },

      getSettings() {
        const channelId = this.channel.id
        if (!channelId) return

        this.loading = true
        settingsService.get(channelId)
          .then(settings => {
            this.loading = false
            this.settings = settings
          })
      }

    },

    created() {
      eventBus.$on(this.$enums.events.settingsClearErrors, this.clearErrors)
    },

    mounted() {
      this.getSettings()
    },

    beforeRouteEnter(to, from, next) {
      prepareChannel(to, next, vm => {
        vm.channelId = to.params.id
        vm.getSettings()
      })
    }
  }
</script>
